import React from "react";
import{BulletIcon} from "../../assets";
import useOnScreen from "../../hooks/useOnScreen";

const Why = () => {
  const [ref, isVisible] = useOnScreen({ threshold: 0.1 });
  const painPoints = [
    "Bingung harus mulai dari mana",
    "Tidak ada yang mengoreksi",
    "Tidak ada teman belajar",
    "Biaya retake IELTS 3 juta+",
    "Tidak punya strategi yang tepat",
  ];

  return (
    <section className="st-surface-navy overflow-x-clip py-12 sm:py-14" id="whyus" ref={ref}>
      <div className="mx-auto w-full max-w-6xl px-6 py-10 sm:px-8 sm:py-12 lg:px-12 lg:py-14">
        <div className="grid items-start gap-8 lg:grid-cols-[1fr_1.25fr] lg:gap-10">
          <div className={`${isVisible ? "animate__animated animate__fadeInLeft" : ""}`}>
            <h2
              className="st-font-display st-text-cream-heading text-[52px] leading-[1.02] sm:text-[58px] lg:text-[45px]"
            >
              <em className="font-normal">Kenapa</em> <span className="font-bold">Banyak</span>
              <br />
              <em className="font-normal">Orang</em> <span className="font-bold">Stuck di</span>
              <br />
              <span className="font-bold">IELTS?</span>
            </h2>

            <p
              className="st-font-body st-text-cream mt-[2.5rem] max-w-md text-[29px] leading-[1.3] sm:text-[22px] lg:mt-[10rem]"
            >
              Banyak pelajar merasa <strong>stuck</strong> karena belajar <strong>tanpa arah, tanpa feedback, </strong>
              dan <strong>tanpa strategi</strong> yang jelas.
            </p>
          </div>

          <div className={`${isVisible ? "animate__animated animate__fadeInRight" : ""}`}>
            <ul className="space-y-4">
              {painPoints.map((text, index) => (
                <li
                  key={index}
                  className={`st-pain-card ${
                    isVisible ? "animate__animated animate__fadeInUp" : ""
                  }`}
                >
                  <img
                    src={BulletIcon}
                    alt="bullet icon"
                    className="h-7 w-7 shrink-0"
                    loading="lazy"
                  />
                  <p
                    className="st-font-body st-text-red-strong w-full text-left text-[18px] font-medium leading-[1.2] sm:text-[22px]"
                  >
                    {text}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why;